import { render, staticRenderFns } from "./declaration-config-form.vue?vue&type=template&id=8548c0d0&"
import script from "./declaration-config-form.vue?vue&type=script&lang=js&"
export * from "./declaration-config-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "declaration-config-form.vue"
export default component.exports